

// Init
easyScrollDots({
  'fixedNav': false,
  'fixedNavId': '',
  'fixedNavUpward': false,
  'offset': 0
});

$(".cacao-slider").slick({
  infinite: false,
  arrows: true,
  speed: 1000,
  slidesToShow: 1,
  lazyLoad: 'ondemand',
  prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
  <path d="M11 21L1 11L11 1" stroke="#5A5A5A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></div>`,
  nextArrow: `<div  class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
  <path d="M1 21L11 11L1 1" stroke="#5A5A5A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></div>`
});
$('.nexxer').click( function(event) {
  event.preventDefault()
  $('.cacao-slider').slick('slickGoTo', 2);
})
$('.collab-slider').slick({
  lazyLoad: 'ondemand',
  infinite: true,
  slidesToShow: 3,
  adaptiveHeight: true,
  slidesToScroll: 3,
  dots: false,
  arrows: true,
  prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
  <path d="M11 21L1 11L11 1" stroke="#5A5A5A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></div>`,
  nextArrow: `<div  class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
  <path d="M1 21L11 11L1 1" stroke="#5A5A5A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></div>`,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
  ]
});